export default "__VITE_ASSET__y7av$ntD__"